import React, { useEffect } from "react";

import { collection, orderBy, query, where } from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { useLeague } from "context/leagueContext";

function useTournamentData() {
  const {
    state: { leagueInfo },
    dispatch,
  } = useLeague();

  const firestore = useFirestore();

  /* 
    Get all tournament rounds. 
    TODO: Filter already here on those that are included in the league?
     */
  const tournamentRoundsCollection = collection(
    firestore,
    "leagues/" +
      leagueInfo?.leagueRef +
      "/seasons/" +
      leagueInfo?.seasonRef +
      "/rounds"
  );
  const tournamentRoundsQuery = query(
    tournamentRoundsCollection,
    //where(documentId(), "in", leagueInfo?.rounds),
    orderBy("deadline")
  );
  const { status: tournamentRoundsStatus, data: tournamentRounds } =
    useFirestoreCollectionData(tournamentRoundsQuery, {
      idField: "id",
    });

  /* 
    Get tournament teams
     */
  const tournamentTeamsCollection = collection(
    firestore,
    "leagues/" +
      leagueInfo?.leagueRef +
      "/seasons/" +
      leagueInfo?.seasonRef +
      "/teams"
  );
  const tournamentTeamsQuery = query(tournamentTeamsCollection);
  const { status: tournamentTeamsStatus, data: tournamentTeams } =
    useFirestoreCollectionData(tournamentTeamsQuery);

  /* 
    Get tournament settings
     */
  //TODO: Not sure why getting doc is not working here.
  const tournamentCollection = collection(
    firestore,
    "leagues/" + leagueInfo?.leagueRef + "/seasons"
  );
  const tournamentQuery = query(tournamentCollection);
  const { status: tournamentStatus, data: tournamentInfoData } =
    useFirestoreCollectionData(tournamentQuery, {
      idField: "id",
    });

  useEffect(() => {
    if (
      tournamentRoundsStatus === "success" &&
      tournamentTeamsStatus === "success" &&
      tournamentStatus === "success" &&
      leagueInfo?.seasonRef &&
      tournamentRounds &&
      tournamentTeams &&
      tournamentInfoData
    ) {
      let tournamentInfoDoc = tournamentInfoData?.find(
        (x) => x.id === leagueInfo?.seasonRef
      );

      dispatch({
        type: "setLeagueData2",
        value: {
          tournamentTeams: tournamentTeams,
          tournamentRounds: tournamentRounds,
          tournamentInfo: tournamentInfoDoc,
        },
      });
    }
  }, [
    tournamentRoundsStatus,
    tournamentTeamsStatus,
    leagueInfo?.seasonRef,
    tournamentTeams,
    tournamentRounds,
    tournamentInfoData,
    tournamentStatus,
  ]);

  return null;
}

export { useTournamentData };
